module.exports = __webpack_public_path__ + "static/029_001-3cb7ad61518b3be88d1f91d170009d8c.jpg";